module.exports = __webpack_public_path__ + "img/19.f51c0da3.svg";